import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
import NewsletterPopup from "./pages/NewsletterPopup";
import UpdateProfilePopup from "./pages/UpdateProfilePopup";

const LazyHomePage = lazy(() => import("./pages/HomePage"));
// const LazyLogin = lazy(() => import("./pages/auth/Login"));
const LazyLogin = lazy(() => import("./pages/HomePage"));
const LazySignup = lazy(() => import("./pages/auth/Signup"));
const LazyForgotPassword = lazy(() => import("./pages/auth/ForgotPassword"));
const LazyResetPassword = lazy(() => import("./pages/auth/ResetPassword"));
const LazyShopingCart = lazy(() => import("./pages/ShoppingCart"));
const LazyCheckout = lazy(() => import("./pages/Checkout"));
const LazyBrandHeroes = lazy(() => import("./pages/BrandHeroes"));
const LazyBlog = lazy(() => import("./pages/Blog"));
const LazyBlogDetails = lazy(() => import("./pages/BlogDetails"));
const LazyAboutus = lazy(() => import("./pages/Aboutus"));
const LazySitemap = lazy(() => import("./pages/sitemap"));

const LazyWarranty = lazy(() => import("./pages/Warranty"));
const LazyCameras = lazy(() => import("./pages/Cameras"));
const LazyCamerasDetails = lazy(() => import("./pages/CamerasDetails"));
const LazyProductReivews = lazy(() => import("./pages/ProductReviews"));
const LazyYoutubeVideos = lazy(() => import("./pages/YoutubeVideos"));
const LazyDashcamera = lazy(() => import("./pages/Dashcamera"));
const LazyProjector = lazy(() => import("./pages/Projector")); // Lazy load the Projector page

// const LazySoundbarDetails = lazy(() => import("./pages/SuondbarDetails"));
const LazyContactUs = lazy(() => import("./pages/Contactus"));
const LazyPrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const LazyShipping = lazy(() => import("./pages/Shipping"));
const LazyRefundPolicy = lazy(() => import("./pages/RefundPolicy"));
const LazyWarrantyPolicy = lazy(() => import("./pages/WarrantyPolicy"));

const LazyTermsCondition = lazy(() => import("./pages/TermsCondition"));
const LazyFaq = lazy(() => import("./pages/Faq"));
const LazyWorldOfFitSpark = lazy(() => import("./pages/WorldOfFitSpark"));
// const LazySoundbar = lazy(() => import("./pages/Soundbar")); // Lazy load the Projector page

const LazySnowBoarding = lazy(() => import("./pages/SnowBoarding"));
const LazyAccessories = lazy(() => import("./pages/Accessories"));
const LazyDownload = lazy(() => import("./pages/Download"));
const LazyMyAccount = lazy(() => import("./pages/MyAccount"));
const LazyOrder = lazy(() => import("./pages/OrderList"));
const LazyChangePassword = lazy(() => import("./pages/ChangePassword"));
const LazyMyAddress = lazy(() => import("./pages/MyAddress"));
const LazyCareer = lazy(() => import("./pages/career"));
const LazyCareerDetails = lazy(() => import("./pages/careerDetails"));
const LazyLifestyle = lazy(() => import("./pages/Lifestyle"));
const LazyNotFound = lazy(() => import("./pages/NotFound"));
const Invoice = lazy(() => import("./pages/Invoice"));
const BlogDetailsNew = lazy(() => import("./pages/BlogDetailsNew"));

// const stripePromise = loadStripe(
//   "pk_test_51RLIj8FpnBeaQJFbDQhny2Pj9PKAjyeiRmehE0yXNxxNY0SzhhaA9dNvICTp29zrntkvCj0ujW7VTaQIPudnP7JJ00bvCh1Xe9"
// );

function App() {
  return (
    // <HomePage />
    <BrowserRouter>
      <NewsletterPopup />
      <UpdateProfilePopup />
      <Routes>
        
        {/* 301 redirect here */}
        <Route 
          path="/cameras/dolphin-10-action-camera-creator-pack" 
          element={<Navigate to="/cameras/dolphin-1-action-camera-creator-pack" replace />} 
        />
        
        {/* <Route path="*" element={<NoPage />} /> */}
        <Route
          path="/login"
          element={
            <Suspense fallback={<div></div>}>
              <LazyLogin />
            </Suspense>
          }
        />
        {/* <Route
          path="/register"
          element={
            <Suspense fallback={<div></div>}>
              <LazySignup />
            </Suspense>
          }
        /> */}
        <Route
          path="/Invoice"
          element={
            <Suspense fallback={<div></div>}>
              <Invoice />
            </Suspense>
          }
        />
        {/*<Route
          path="/forgot-password"
          element={
            <Suspense fallback={<div></div>}>
              <LazyForgotPassword />
            </Suspense>
          }
        />*/}
        {/* <Route
          path="/reset-password/:userId/:token"
          element={
            <Suspense fallback={<div></div>}>
              <LazyResetPassword />
            </Suspense>
          }
        />*/}
        <Route
          path="/"
          element={
            <Suspense fallback={<div></div>}>
              <LazyHomePage />
            </Suspense>
          }
        />
        <Route
          path="/youtube-videos"
          element={
            <Suspense fallback={<div></div>}>
              <LazyYoutubeVideos />
            </Suspense>
          }
        />
        <Route
          path="/shopping-cart"
          element={
            <Suspense fallback={<div></div>}>
              <LazyShopingCart />
            </Suspense>
          }
        />
        <Route
          path="/checkout"
          element={
            // <PrivateRoute>
            <Suspense fallback={<div></div>}>
              {/* <Elements stripe={stripePromise}> */}
              <LazyCheckout />
              {/* </Elements> */}
            </Suspense>
            // </PrivateRoute>
          }
        />
        <Route
          path="/brand-heroes"
          element={
            <Suspense fallback={<div></div>}>
              <LazyBrandHeroes />
            </Suspense>
          }
        />
        <Route
          path="/blog"
          element={
            <Suspense fallback={<div></div>}>
              <LazyBlog />
            </Suspense>
          }
        />
        <Route
          path="/blog/:slug"
          element={
            <Suspense fallback={<div></div>}>
              <BlogDetailsNew />
            </Suspense>
          }
        />
         
        
        <Route
          path="/about_us"
          element={
            <Suspense fallback={<div></div>}>
              <LazyAboutus />
            </Suspense>
          }
        />

        <Route
          path="/sitemap"
          element={
            <Suspense fallback={<div></div>}>
              <LazySitemap />
            </Suspense>
          }
        />
        {/* Projector page route */}

        {/* Projector page route */}
        {/* <Route
          path="/soundbar"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <LazySoundbar /> 
            </Suspense>
          }
        /> */}

        <Route
          path="/career"
          element={
            <Suspense fallback={<div></div>}>
              <LazyCareer />
            </Suspense>
          }
        />
        <Route
          path="/career/:id"
          element={
            <Suspense fallback={<div></div>}>
              <LazyCareerDetails />
            </Suspense>
          }
        />
        <Route
          path="/life-style-gear/:slug"
          element={
            <Suspense fallback={<div></div>}>
              <LazyLifestyle />
            </Suspense>
          }
        />
        <Route
          path="/dashcamera"
          element={
            <Suspense fallback={<div></div>}>
              <LazyDashcamera />
            </Suspense>
          }
        />
        <Route
          path="/dashcamera/:slug"
          element={
            <Suspense fallback={<div></div>}>
              <LazyCamerasDetails />
            </Suspense>
          }
        />

        <Route
          path="/projector"
          element={
            <Suspense fallback={<div></div>}>
              <LazyProjector />
            </Suspense>
          }
        />
        <Route
          path="/projector/:slug"
          element={
            <Suspense fallback={<div></div>}>
              <LazyCamerasDetails />
            </Suspense>
          }
        />

        <Route
          path="/action-cameras"
          element={
            <Suspense fallback={<div></div>}>
              <LazyCameras />
            </Suspense>
          }
        />
        <Route
          path="/cameras/:slug"
          element={
            <Suspense fallback={<div></div>}>
              <LazyCamerasDetails />
            </Suspense>
          }
        />
        <Route
          path="/accessories/:slug"
          element={
            <Suspense fallback={<div></div>}>
              <LazyCamerasDetails />
            </Suspense>
          }
        />
        <Route
          path="/product/review/:slug"
          element={
            <Suspense fallback={<div></div>}>
              <LazyProductReivews />
            </Suspense>
          }
        />
        <Route
          path="/contact_us"
          element={
            <Suspense fallback={<div></div>}>
              <LazyContactUs />
            </Suspense>
          }
        />
         <Route
          path="/warranty"
          element={
            <Suspense fallback={<div></div>}>
              <LazyWarranty />
            </Suspense>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <Suspense fallback={<div></div>}>
              <LazyPrivacyPolicy />
            </Suspense>
          }
        />

        <Route
          path="/shipping"
          element={
            <Suspense fallback={<div></div>}>
              <LazyShipping />
            </Suspense>
          }
        />
        <Route
          path="/refund-policy"
          element={
            <Suspense fallback={<div></div>}>
              <LazyRefundPolicy />
            </Suspense>
          }
        />
        <Route
          path="/warranty-policy"
          element={
            <Suspense fallback={<div></div>}>
              <LazyWarrantyPolicy />
            </Suspense>
          }
        />
        <Route
          path="/terms-condition"
          element={
            <Suspense fallback={<div></div>}>
              <LazyTermsCondition />
            </Suspense>
          }
        />
        <Route
          path="/faq"
          element={
            <Suspense fallback={<div></div>}>
              <LazyFaq />
            </Suspense>
          }
        />
        <Route
          path="/world-of-fitspark"
          element={
            <Suspense fallback={<div></div>}>
              <LazyWorldOfFitSpark />
            </Suspense>
          }
        />
        <Route
          path="/world-of-fitspark/:slug"
          element={
            <Suspense fallback={<div></div>}>
              <LazySnowBoarding />
            </Suspense>
          }
        />
        <Route
          path="/accessories"
          element={
            <Suspense fallback={<div></div>}>
              <LazyAccessories />
            </Suspense>
          }
        />
        <Route
          path="/download"
          element={
            <Suspense fallback={<div></div>}>
              <LazyDownload />
            </Suspense>
          }
        />
        <Route
          path="/my-account"
          element={
            <PrivateRoute>
              <Suspense fallback={<div></div>}>
                <LazyMyAccount />
              </Suspense>
            </PrivateRoute>
          }
        />
        <Route
          path="/order"
          element={
            <PrivateRoute>
              <Suspense fallback={<div></div>}>
                <LazyOrder />
              </Suspense>
            </PrivateRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <PrivateRoute>
              <Suspense fallback={<div></div>}>
                <LazyChangePassword />
              </Suspense>
            </PrivateRoute>
          }
        />
        <Route
          path="/my-address"
          element={
            <PrivateRoute>
              <Suspense fallback={<div></div>}>
                <LazyMyAddress />
              </Suspense>
            </PrivateRoute>
          }
        />
        <Route
          path="*"
          element={
            <Suspense fallback={<div></div>}>
              <LazyNotFound />
            </Suspense>
          }
        />
        

      </Routes>
    </BrowserRouter>
  );

}

export default App;
